<template>
    <div>
        <input v-model="value" @input="search" @focus="show(true)" @blur="blur" placeholder="Search for a number" type="text" />
        <slot></slot>
        <div v-if="timeout || error" class="form-control-feedback" :title="error">
            <fa v-if="error" class="text-danger fa-warning"></fa>
            <fa v-else class="fa-spin fa-circle-notch"></fa>
        </div>
        <div v-show="list.length && showlist" class="input-group">
            <ul class="dropdown-menu dropdown-menu-end show">
                <li v-for="item in list" :key="item.phoneNumber">
                    <a class="dropdown-item" :href="item.phoneNumber" @click.prevent="select(item)">
                        <span v-html="highlighted(item.friendlyName)"></span><br />
                        <small class="text-dark">{{ item.rateCenter }} {{ item.region }}</small>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';

    const phonechars = { a: 2, b: 2, c: 2, d: 3, e: 3, f: 3, g: 4, h: 4, i: 4, j: 5, k: 5, l: 5, m: 6, n: 6, o: 6, p: 7, q: 7, r: 7, s: 7, t: 8, u: 8, v: 8, w: 9, x: 9, y: 9, z: 9 };
    function makeDigits(str) {
        let digits = '';
        Array.from(str).forEach(c => {
            digits += (phonechars[c.toLowerCase()] ?? (c.match(/[0-9]/) ? c : ''));
        });
        return digits;
    }

    export default {
        props: {
            modelValue: { type: String },
        },
        emits: ['update:model-value'],
        data: function () {
            return {
                error: null,
                list: [],
                showlist: true,
                timeout: 0,
                value: '',
            };
        },
        methods: {
            blur() {
                setTimeout(() => this.show(false), 100);
            },
            highlighted(num) {
                let pattern = '';
                let digits = makeDigits(this.value);
                Array.from(digits).forEach(c => {
                    pattern += c + '[^0-9]*';
                });
                pattern = `(${pattern})`;
                return num.replaceAll(RegExp(pattern, 'g'), '<b>$1</b>');
            },
            search() {
                const vm = this;
                clearTimeout(vm.timeout);
                vm.timeout = setTimeout(() => {
                    if (vm.value.length > 1) {
                        vm.error = null;
                        axios.get('/callconfigs/findnumber', { params: { q: vm.value } })
                            .then(r => {
                                vm.list = r.data;
                                vm.showlist = true;
                                vm.error = null;
                                vm.timeout = 0;
                            }).catch(e => {
                                vm.error = e.message;
                            });
                    }
                }, 1000);
            },
            select(phone) {
                this.value = phone.phoneNumber;
                this.list = [];
            },
            show(yes) {
                this.showlist = yes;
            },
            updateValue() {
                this.$emit('update:model-value', this.value);
            }
        },
        watch: {
            modelValue: {
                handler(value) {
                    this.value = value;
                },
                immediate: true,
            },
            value() {
                this.updateValue();
            }
        }
    }
</script>